var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useState } from 'react';
import { cs, getCollectionGroups, isSubArray, retrieveBlocks } from '../utils';
import { useNotionContext } from '../context';
import { CollectionCard } from './collection-card';
import { CollectionGroup } from './collection-group';
import { UseRetrieveBlocks } from '../hooks/useRetrieveBlocks';
export var CollectionViewGallery = function (_a) {
    var _b;
    var collection = _a.collection, collectionView = _a.collectionView, collectionData = _a.collectionData;
    var recordMap = useNotionContext().recordMap;
    var isGroupedCollection = (_b = collectionView === null || collectionView === void 0 ? void 0 : collectionView.format) === null || _b === void 0 ? void 0 : _b.collection_group_by;
    var _c = UseRetrieveBlocks(), retrieveMissingBlocks = _c.retrieveMissingBlocks, retrieveGroupBlocks = _c.retrieveGroupBlocks;
    if (isGroupedCollection) {
        var collectionGroups_1 = getCollectionGroups(collection, collectionView, collectionData);
        var allBlocks = retrieveGroupBlocks(collectionGroups_1, collectionData, collection).blockIds.flat();
        retrieveMissingBlocks(allBlocks.map(function (id) { return ({ id: id, table: 'block' }); }));
        return collectionGroups_1.map(function (group, index) {
            var _a, _b;
            var retrievedVals = retrieveGroupBlocks(collectionGroups_1, collectionData, collection);
            var value = ((_a = retrievedVals.values) === null || _a === void 0 ? void 0 : _a[index]) || [];
            group.blockIds = ((_b = retrievedVals.blockIds) === null || _b === void 0 ? void 0 : _b[index]) || [];
            return (React.createElement(CollectionGroup, __assign({ key: index }, __assign(__assign({}, group), { value: value }), { collectionViewComponent: Gallery })));
        });
    }
    var blockIds = retrieveBlocks(collection, collectionView, collectionData, recordMap);
    // if we couldn't find the blocks in the current view, check other views.
    if (blockIds.length === 0) {
        // retrieve the views
        var views = recordMap.collection_query[collection.id] || {};
        for (var viewId in views) {
            if (viewId == collectionView.id)
                continue;
            var ids = retrieveBlocks(collection, collectionView, collectionData, recordMap);
            if (ids.length > 0) {
                blockIds.push.apply(blockIds, ids);
                break;
            }
        }
    }
    retrieveMissingBlocks(blockIds.map(function (id) { return ({ id: id, table: 'block' }); }));
    return (React.createElement(Gallery, { collectionView: collectionView, collection: collection, blockIds: blockIds }));
};
function Gallery(_a) {
    var _b, _c, _d;
    var blockIds = _a.blockIds, collectionView = _a.collectionView, collection = _a.collection;
    // console.log({collection, collectionView})
    var recordMap = useNotionContext().recordMap;
    var _e = useState({}), imageBlocks = _e[0], setImageBlocks = _e[1];
    // const [initialized, setInitialized] = useState(false)
    var _f = UseRetrieveBlocks(), retrieveMissingImageBlocks = _f.retrieveMissingImageBlocks, retrieveMissingBlocks = _f.retrieveMissingBlocks;
    var _g = collectionView.format || {}, _h = _g.gallery_cover, gallery_cover = _h === void 0 ? { type: 'none' } : _h, _j = _g.gallery_cover_size, gallery_cover_size = _j === void 0 ? 'medium' : _j, _k = _g.gallery_cover_aspect, gallery_cover_aspect = _k === void 0 ? 'cover' : _k;
    var applyBlockFilter = useCallback(function (blockIds, filters) {
        var handFilter = function (blockId) {
            var _a, _b, _c, _d, _e, _f;
            var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
            // console.log({block, filters})
            var condition = true;
            var galleryPropertiesDict = {};
            (_c = (_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.gallery_properties) === null || _c === void 0 ? void 0 : _c.forEach(function (prop) {
                if (prop.visible) {
                    galleryPropertiesDict[prop.property] = prop;
                }
            });
            // console.log({galleryPropertiesDict})
            for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
                var filter = filters_1[_i];
                var dFilter = filter === null || filter === void 0 ? void 0 : filter.filter;
                switch (dFilter.filter.operator) {
                    case 'date_is_relative_to': {
                        break;
                    }
                    default: {
                        if (dFilter.property in galleryPropertiesDict) {
                            try {
                                // console.log('dFilter.property ',dFilter.property)
                                var blockProp = ((_e = (_d = block === null || block === void 0 ? void 0 : block.properties[dFilter.property]) === null || _d === void 0 ? void 0 : _d.flat()) === null || _e === void 0 ? void 0 : _e.flat()) || [];
                                // console.log('BlockProp ',blockProp[0])
                                var valuesObject = (_f = dFilter === null || dFilter === void 0 ? void 0 : dFilter.filter) === null || _f === void 0 ? void 0 : _f.value;
                                // console.log({valuesObject})
                                var values = Array.isArray(valuesObject)
                                    ? valuesObject.map(function (v) { return v.value; })
                                    : [valuesObject.value];
                                // console.log({values})
                                // condition = Array.isArray(valuesObject)
                                //   ? isSubArray(values, blockProp)
                                //   : true
                                if (Array.isArray(valuesObject)) {
                                    condition = isSubArray(values, blockProp);
                                }
                                // console.log({condition})
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                }
            }
            return condition;
        };
        // console.log({blockIds})
        return blockIds.filter(function (blockId) { return handFilter(blockId); });
    }, [recordMap]);
    // check all the blocks for image and if not found, check the column list
    if (blockIds.length > 0 &&
        (gallery_cover === null || gallery_cover === void 0 ? void 0 : gallery_cover.type) === 'page_content' &&
        Object.keys(imageBlocks).length == 0) {
        retrieveMissingImageBlocks(blockIds, gallery_cover).then(function (pictureBlocks) {
            if (pictureBlocks)
                setImageBlocks(function (blocks) { return (__assign(__assign({}, blocks), pictureBlocks)); });
        });
    }
    var filters = (_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.property_filters;
    if (filters) {
        blockIds = applyBlockFilter(blockIds, filters);
        // console.log('apply block filter ',{blockIds})
    }
    var missingBlocks = [];
    for (var _i = 0, blockIds_1 = blockIds; _i < blockIds_1.length; _i++) {
        var blockId = blockIds_1[_i];
        var ids = ((_d = (_c = recordMap.block[blockId]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.content) || [];
        missingBlocks = __spreadArray(__spreadArray([], missingBlocks, true), ids.filter(function (id) { var _a; return !((_a = recordMap.block[id]) === null || _a === void 0 ? void 0 : _a.value); }), true);
    }
    var userGalleryMiss = blockIds.includes('80f0b0fe-7d13-471f-b28e-8fe0fc5170f0');
    missingBlocks = userGalleryMiss ? blockIds : missingBlocks;
    retrieveMissingBlocks(missingBlocks.map(function (id) { return ({ id: id, table: 'block' }); }));
    return (React.createElement("div", { className: 'notion-gallery' },
        React.createElement("div", { className: 'notion-gallery-view' },
            React.createElement("div", { className: cs('notion-gallery-grid', "notion-gallery-grid-size-".concat(gallery_cover_size)) }, blockIds.map(function (blockId) {
                var _a, _b;
                var block = (_a = recordMap.block[blockId]) === null || _a === void 0 ? void 0 : _a.value;
                if (!block)
                    return null;
                if (block.properties == undefined)
                    return null;
                if (block.format == undefined &&
                    !('7d13eb7d-5c52-4899-a074-8e907e90e3f2' in recordMap.block))
                    return null;
                return (React.createElement(CollectionCard, { collection: collection, block: block, cover: gallery_cover, imageBlock: imageBlocks[blockId], coverSize: gallery_cover_size, coverAspect: gallery_cover_aspect, properties: (_b = collectionView.format) === null || _b === void 0 ? void 0 : _b.gallery_properties, key: blockId }));
            })))));
}
//# sourceMappingURL=collection-view-gallery.js.map